import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-3, message, chat"} maskId="square-filled-radius-0-stroke-1-IconBubble3"><path d="M12.0007 2C6.47784 2 2.00069 6.47715 2.00069 12C2.00069 13.5885 2.37141 15.0917 3.03144 16.4266L1.86133 22.1283L7.70822 21.0343C9.00943 21.6536 10.4653 22 12.0007 22C17.5235 22 22.0007 17.5228 22.0007 12C22.0007 6.47715 17.5235 2 12.0007 2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubble3;
